import React, { useState, useEffect } from "react";
// import claylogo from "../assets/images/logo/Clay World School-Logo.png";
import "../assets/css/animate/animate.min.css";
import "../assets/css/bootstrap/bootstrap.min.css";
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/font-awesome/all.min.css";
import "../assets/css/magnific-popup/magnific-popup.css";
import "../assets/css/owl-carousel/owl.carousel.min.css";
import "../assets/css/select2/select2.css";
import "../assets/css/swiper/swiper.min.css";
import "../assets/css/style.css";
import { Link } from "react-router-dom";
import { useContactForm } from "../context/ContactFormContext";
import logoImg from "../assets/images/logo/ludhiana_logo.png";
// import ContactFormModal from "./ContactFormModal";

export default function Header() {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  // const [scrollProgress, setScrollProgress] = useState(0);
  const [aboutUsDropdownOpen, setAboutUsDropdownOpen] = useState(false);
  const [admissionDropdownOpen, setAdmissionDropdownOpen] = useState(false);
  const [scholasticsDropdownOpen, setScholasticsDropdownOpen] = useState(false);
  const [SchollifeDropdownOpen, setSchollifeDropdownopen] = useState(false);
  const [ParentcornerDropdownOpen, setParentcornerDropdownOpen] =
    useState(false);
  const [MediaRoomDropdownopen, setMediaRoomDropdownopen] = useState(false);
  const [GalleryDropdownOpen, setGalleryDropdownOpen] = useState(false);
  const [dropdownsOpen, setDropdownsOpen] = useState({
    aboutUs: false,
    admission: false,
    scholastics: false,
    schoolLife: false,
    parentCorner: false,
    mediaRoom: false,
    gallery: false,
  });

  // const { openContactForm, closeContactForm } = useContactForm();

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768); // Adjust 768px as per your breakpoint
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768); // Toggle based on screen width
    };

    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };
  const toggleAboutUsDropdown = () => {
    setAboutUsDropdownOpen(!aboutUsDropdownOpen);
  };

  const toggleAdmissionDropdown = () => {
    setAdmissionDropdownOpen(!admissionDropdownOpen);
  };

  const toggleScholasticsDropdown = () => {
    setScholasticsDropdownOpen(!scholasticsDropdownOpen);
  };

  const toggleSchollifeDropdown = () => {
    setSchollifeDropdownopen(!SchollifeDropdownOpen);
  };
  const toggleParentcornerDropdown = () => {
    setParentcornerDropdownOpen(!ParentcornerDropdownOpen);
  };
  const toggleMediaRoomDropdown = () => {
    setMediaRoomDropdownopen(!MediaRoomDropdownopen);
  };
  const toggleGalleryDropdown = () => {
    setGalleryDropdownOpen(!GalleryDropdownOpen);
  };

  const toggleDropdown = (dropdown) => {
    setDropdownsOpen({
      ...dropdownsOpen,
      [dropdown]: !dropdownsOpen[dropdown],
    });
  };

  const closeNavbar = () => {
    setIsNavbarOpen(false);
    setDropdownsOpen({
      aboutUs: false,
      admission: false,
      scholastics: false,
      schoolLife: false,
      parentCorner: false,
      mediaRoom: false,
      gallery: false,
    });
    // closeContactForm();
  };

  return (
    <>
      {/* Scroll Progress Bar */}
      {/* <div
        style={{
          height: '4px',
          backgroundColor: '#007bff',
          width: `${scrollProgress}%`,
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 1001,
          transition: 'width 0.1s ease-out',
          display: scrollProgress > 0 ? 'block' : 'none',
        }}
      ></div> */}
      {/* Header */}
      <header className={`header header-sticky ${isSticky ? 'sticky-top' : ''}`}>
        <marquee
          className="mainheader"
          style={{
            fontSize: '16px',
            fontWeight: 500,
            paddingTop: '5px',
            fontFamily: 'sans-serif',
            backgroundColor: 'white'
          }}
        >
          <span style={{ color: 'red' }}>
            Books of Millennium can be bought online also.Parents can buy NCERT books for Grade IX & X.
          </span>
          <span style={{ color: '#007bff', marginLeft: '10px', marginRight: '10px' }}>|</span>
          <span style={{ color: '#007bff' }}>
            This school is owned and managed by Maharaja Ranjit Singh Education Trust.
          </span>
        </marquee>
        <div className="topbar py-2 d-none d-lg-flex">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="d-none d-lg-flex align-items-center text-center">
                  <div className="mr-3 d-inline-block">
                    <a
                      className="text-white"
                      href="mailto:info@mwsludhiana.in"
                    >
                      <i className="far fa-envelope mr-2"></i>
                      <span>Email:</span>info@mwsludhiana.in
                    </a>
                  </div>
                  <div className="mr-auto d-inline-block">
                    <a className="text-white" href="tel:9139989898">
                      <i className="fas fa-phone-alt mr-2"></i>
                      <span>Call</span> +91-7986214697
                    </a>
                  </div>
                  <div className="social-icon">
                    <ul className="social-icon">
                      <li>
                        <Link
                          to="https://www.facebook.com/millenniumworldschoolludhiana"
                          target="_blank"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>

                        <Link
                          to="https://www.instagram.com/millenniumworldschoolludhiana/"
                          target="_blank"
                        >
                          <i className="fab fa-instagram"></i>
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to=""
                          target="_blank"
                        >
                          <i className="fab fa-youtube"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          target="_blank"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="header-main py-3">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="d-lg-flex align-items-center">
                  <a className="navbar-brand logo" href="/">
                    <img src={logoImg} alt="Millennium World School Ludhiana" style={{ height: "55px" }} />
                  </a>

                  {/* Navbar */}
                  <nav className="navbar navbar-expand-lg">
                    {/* Navbar Toggler */}
                    <button
                      className={`navbar-toggler ${isNavbarOpen ? "active" : ""
                        }`}
                      type="button"
                      onClick={toggleNavbar}
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Menu */}

                    <div
                      className={`collapse navbar-collapse justify-content-center ${isNavbarOpen ? "show" : ""
                        }`}
                      style={{ marginLeft: 'auto', marginRight: 'auto' }}
                    >
                      <ul className="navbar-nav">
                        {/* Home */}
                        <li className="nav-item">
                          <Link
                            to="/"
                            className="nav-link"
                            onClick={closeNavbar}
                          >
                            Home
                          </Link>
                        </li>

                        {/* About Us Dropdown */}
                        <li
                          className={`nav-item dropdown ${aboutUsDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleAboutUsDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              aboutUsDropdownOpen ? "true" : "false"
                            }
                          >
                            About Us{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* Dropdown Menu */}
                          <ul
                            className={`dropdown-menu ${aboutUsDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/overview"
                                onClick={closeNavbar}
                              >
                                Overview
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/vision-values"
                                onClick={closeNavbar}
                              >
                                Vision & Values
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/research-development"
                                onClick={closeNavbar}
                              >
                                Research & Development
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/faqs"
                                onClick={closeNavbar}
                              >
                                FAQ's
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li
                          className={`nav-item dropdown ${admissionDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleAdmissionDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              admissionDropdownOpen ? "true" : "false"
                            }
                          >
                            Admission
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${admissionDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/admission-overview"
                                onClick={closeNavbar}
                              >
                                Admission Overview
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/admission-procedure"
                                onClick={closeNavbar}
                              >
                                Admission Procedure
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/admission-faqs"
                                onClick={closeNavbar}
                              >
                                FAQ's
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li
                          className={`nav-item dropdown ${scholasticsDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link  dropdown-toggle"
                            role="button"
                            onClick={toggleScholasticsDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              scholasticsDropdownOpen ? "true" : "false"
                            }
                          >
                            Scholastics{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${scholasticsDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/cbse-board-affiliation"
                                onClick={closeNavbar}
                              >
                                CBSE - Board of Affiliation
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/millennium-learning-system"
                                onClick={closeNavbar}
                              >
                                The Millennium Learning System
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/facilitators-development"
                                onClick={closeNavbar}
                              >
                                Facilitators Development
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`nav-item dropdown ${SchollifeDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleSchollifeDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              SchollifeDropdownOpen ? "true" : "false"
                            }
                          >
                            School Life{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${SchollifeDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/school-life-overview"
                                onClick={closeNavbar}
                              >
                                Overview
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/sports"
                                onClick={closeNavbar}
                              >
                                Sports
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/music-and-dance"
                                onClick={closeNavbar}
                              >
                                Music and Dance
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/creative-arts"
                                onClick={closeNavbar}
                              >
                                Creative Arts
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/theatre"
                                onClick={closeNavbar}
                              >
                                Theatre
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/clubs-and-house-council"
                                onClick={closeNavbar}
                              >
                                Clubs and House council
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/social-outreach"
                                onClick={closeNavbar}
                              >
                                Social Outreach
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/facilities"
                                onClick={closeNavbar}
                              >
                                Facilities
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`nav-item dropdown ${ParentcornerDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleParentcornerDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              ParentcornerDropdownOpen ? "true" : "false"
                            }
                          >
                            Parents' Corner{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${ParentcornerDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/parents-as-partners"
                                onClick={closeNavbar}
                              >
                                Parents as Partners
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/parents-speak"
                                onClick={closeNavbar}
                              >
                                Parents' Speak
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/refer-a-friend"
                                onClick={closeNavbar}
                              >
                                Refer a Friend
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/parent-school-association"
                                onClick={closeNavbar}
                              >
                                Parent School Association
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`nav-item dropdown ${MediaRoomDropdownopen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleMediaRoomDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              MediaRoomDropdownopen ? "true" : "false"
                            }
                          >
                            Media Room{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${MediaRoomDropdownopen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/news-and-events"
                                onClick={closeNavbar}
                              >
                                News & Events
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/awards"
                                onClick={closeNavbar}
                              >
                                Awards
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`nav-item dropdown ${GalleryDropdownOpen ? "show" : ""
                            }`}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            role="button"
                            onClick={toggleGalleryDropdown}
                            aria-haspopup="true"
                            aria-expanded={
                              GalleryDropdownOpen ? "true" : "false"
                            }
                          >
                            Gallery{" "}
                            <i className="fas fa-chevron-down fa-xs"></i>
                          </a>
                          {/* <!-- Dropdown Menu --> */}
                          <ul
                            className={`dropdown-menu ${GalleryDropdownOpen ? "show" : ""
                              }`}
                          >
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/photo-gallery"
                                onClick={closeNavbar}
                              >
                                Photo Gallery
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/video-gallery"
                                onClick={closeNavbar}
                              >
                                Video Gallery
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="/contactus"
                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                          >
                            Contact Us
                          </Link>
                        </li>
                        {/* <li className={`nav-item ${isDesktop ? "enquire-tab" : "enquire-tab-mobile"}`}>
                          <a
                            className="nav-link"
                            href="https://forms.liltriangle.com/enquiry-form/n3CR9rL7ek"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={closeNavbar}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            Enquire Now
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <ContactFormModal /> */}
    </>
  );
}
